import React from "react";

import { Visible } from "../core/components";
import ReactTooltip from "react-tooltip";
import Money from "./formatters/Money";

const SpecificationItem = ({
  label,
  value,
  currency,
  extra,
  na = false,
  labelClass,
  tooltip = null,
}) => {
  if (!value && !na) {
    return null;
  }

  let displayValue;
  if (!value && na) {
    displayValue = "N/A";
  } else {
    displayValue =
      currency && !isNaN(parseInt(value)) ? (
        <Money
          amount={value}
          euro={currency === "eur"}
          style={{ fontFamily: "Calibri Bold" }}
        />
      ) : (
        value
      );
  }

  const containerProps = {};

  if (tooltip) {
    containerProps["data-tip"] = tooltip;
  }

  return (
    <div key={label || value}>
      <Visible when={label}>
        <span className={labelClass} style={{ fontFamily: "Calibri Light" }}>
          {label}:&nbsp;
        </span>
      </Visible>
      <span style={{ fontFamily: "Calibri Bold" }} {...containerProps}>
        {displayValue}
        {typeof extra === "string" && ` ${extra}`}
        {typeof extra !== "string" && extra}
      </span>
      <ReactTooltip />
    </div>
  );
};

export default SpecificationItem;
